import * as React from "react";
import { forwardRef } from "react";
const SvgCopyToClipboard = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "#404040" }, /* @__PURE__ */ React.createElement("path", { d: "M16.24 3.46V18.6H1.14V3.46h15.1M17.3 2.4H.08v17.26H17.3V2.4z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.68 16.94L18.62 16.94 18.62 1.1 3 1.1 3 0.04 19.679 0.04z" })));
const ForwardRef = forwardRef(SvgCopyToClipboard);
export { ForwardRef as ReactComponent };
